/* eslint-disable jsx-a11y/click-events-have-key-events */
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import './style.scss';

const Range = ({ id, questionId, className, handleChange }) => {
  const answerValues = [
    { text: '5 - 0', firstValue: 5, lastValue: 0, id: 1 },
    { text: '4 - 1', firstValue: 4, lastValue: 1, id: 2 },
    { text: '3 - 2', firstValue: 3, lastValue: 2, id: 3 },
    { text: '2 - 3', firstValue: 2, lastValue: 3, id: 4 },
    { text: '1 - 4', firstValue: 1, lastValue: 4, id: 5 },
    { text: '0 - 5', firstValue: 0, lastValue: 5, id: 6 }
  ];

  const DEFAULT_RANGE = -6;
  const [valueA, setValueA] = useState(DEFAULT_RANGE);
  const handleSelectAnswer = (event) => {
    let calculateValue = event?.target?.value;

    if (calculateValue < 0) {
      calculateValue *= -1;
      // eslint-disable-next-line
    } else if (calculateValue == 0) {
      calculateValue = DEFAULT_RANGE;
    } else {
      calculateValue = 5 - calculateValue;
    }
    setValueA(calculateValue);
  };

  useEffect(() => {
    const answer = answerValues.find(item => item.firstValue === valueA);
    handleChange(answer);
  }, [valueA]);

  const props = {
    type: 'range',
    className: `${className} answer-range`,
    id: `${questionId}-${id}`,
    name: `answer-${questionId}`,
    onChange: handleSelectAnswer,
  };

  return (
    <Form.Group className="range" as={Row}>
      <Form.Label column sm={3}>{`a (${valueA !== DEFAULT_RANGE ? valueA : 0})`}</Form.Label>
      <Col sm="6">
        <Form.Control {...props} defaultValue={0} custom min="-5" max="5" step="1" />
      </Col>
      <Form.Label column sm={3}>{`b (${valueA !== DEFAULT_RANGE ? 5 - valueA : 0})`}</Form.Label>
    </Form.Group>
  );
};

Range.propTypes = {
  className: PropTypes.string,
  handleChange: PropTypes.func,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  questionId: PropTypes.number
};

Range.defaultProps = {
  className: '',
  handleChange: () => { },
  questionId: 0
};

export default Range;
